import { render } from "./DocumentAndFolderList.vue?vue&type=template&id=11222068"
import script from "./DocumentAndFolderList.vue?vue&type=script&lang=js"
export * from "./DocumentAndFolderList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__